/**
 * Wait specified amount in milliseconds for async operation.
 * @param {Number} waitingTimeout - waiting amount in milliseconds
 */
const wait = (waitingTimeout) => new Promise((resolve) => {
    setTimeout(resolve, waitingTimeout);
});

module.exports = {
    wait
};
